/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * @module enervee_utils.account
 */
AccountSideNavService.$inject = ['AccountAuthService'];
function AccountSideNavService(AccountAuthService) {
    var _pub = {};
    var _numFavoriteProducts = 0;
    var _searchesCount = 0;
    /**
     * Gets the currently logged-in user's account side nav info
     *
     * @returns {*}
     */
    _pub.getAccountSideNavInfo = function () {
        return AccountAuthService.fetchCurrentUserInfo().then(function () {
            const currentUserInfo = AccountAuthService.getCurrentUser();
            if (currentUserInfo) {
                _pub.updateSideNavFavoriteProductCount(currentUserInfo.favorite_product_count);
                _pub.updateSideNavSearchesCount(currentUserInfo.searches_count);
            }
            return currentUserInfo;
        });
    };


    /**
     * Updates the number of favorite products for the current user
     *
     * @param {Number} favoriteProductCount
     * @returns {*}
     */
    _pub.updateSideNavFavoriteProductCount = function (favoriteProductCount) {
        _numFavoriteProducts = favoriteProductCount;
    };

    /**
     * Returns number of favorite products
     * @returns {number}
     */
    _pub.getNumFavoriteProducts = function () {
        return _numFavoriteProducts;
    };

    /**
     * Updates the number of saved searches for the current user
     *
     * @param {Number} searchesCount
     * @returns {*}
     */
    _pub.updateSideNavSearchesCount = function (searchesCount) {
        _searchesCount = searchesCount;
    };

    /**
     * Returns number of saved searches
     * @returns {number}
     */
    _pub.getSearchesCount = function () {
        return _searchesCount;
    };

    return _pub;
}

module.exports = AccountSideNavService;